import MediaComponent from "./MediaComponent";

export default MediaComponent;
